import moment from 'moment-timezone';

const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');

dayjs.extend(utc);

export function tryFormatDate(isoTimestamp, withTime = false, format = 'MM/DD/YYYY') {
  try {
    const clientTimezone = moment.tz.guess(true);
    const clientTime = moment.tz(isoTimestamp, clientTimezone);

    if (withTime) {
      return clientTime.format(`${format} - h:mm A`);
    }

    return clientTime.format(format);
  } catch (e) {
    return isoTimestamp;
  }
}

export function isSameDay(a, b) {
  return dayjs.utc(a).isSame(dayjs.utc(b), 'day');
}

export function isPast(date) {
  try {
    return moment().diff(date) > 0;
  } catch (e) {
    console.log('==============================================\n'); // eslint-disable-line no-console
    console.log('Date parsing error in isPast:', e, '\n'); // eslint-disable-line no-console
    console.log('==============================================\n'); // eslint-disable-line no-console
    return false;
  }
}

export function formatDateTimeToClientLocal(originalDateTime, format = 'h:mm a, MMM D, YYYY') {
  return dayjs.utc(originalDateTime).local().format(format);
}

export const getDateObject = input => {
  if (!input) return null;

  // Already Date → normalize to local date-only
  if (input instanceof Date) {
    return new Date(
      input.getFullYear(),
      input.getMonth(),
      input.getDate()
    );
  }

  if (typeof input === 'string') {
    // ISO datetime used to represent DATE
    if (input.includes('T')) {
      // DO NOT new Date(input).  Remove timestamp first
      const datePart = input.split('T')[0]; // "2025-11-17"
      const [y, m, d] = datePart.split('-').map(Number);
      return new Date(y, m - 1, d);
    }

    if (input.includes(' ')) {
      // DO NOT new Date(input).  Remove timestamp first
      const datePart = input.split(' ')[0]; // "2025-11-17"
      const [y, m, d] = datePart.split('-').map(Number);
      return new Date(y, m - 1, d);
    }

    // YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [y, m, d] = input.split('-').map(Number);
      return new Date(y, m - 1, d);
    }

    // MM/DD/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(input)) {
      const [m, d, y] = input.split('/').map(Number);
      return new Date(y, m - 1, d);
    }
  }

  return null;
};

export const getDateString = (date, format = 'YYYY-MM-DD') => {
  if (!date) return '';

  const dateObject = typeof date === 'string' ? getDateObject(date) : date;

  const year = dateObject.getFullYear();
  const month = (`0${dateObject.getMonth() + 1}`).slice(-2);
  const day = (`0${dateObject.getDate()}`).slice(-2);

  if (format === 'MM/DD/YYYY') {
    return `${month}/${day}/${year}`;
  }

  return `${year}-${month}-${day}`;
};

export const getCurrentTimestamp = () => {
  const now = new Date();

  // Get date components
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const day = now.getDate().toString().padStart(2, '0');

  // Get time components
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');

  // Create the timestamp string
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const isValidDateString = dateString => {
  // Check if the string matches the M/D/YYYY format
  const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  if (!dateRegex.test(dateString)) {
    return false;
  }

  // Parse the date
  const [month, day, year] = dateString.split('/').map(Number);

  // Validate date parts
  const date = new Date(year, month - 1, day); // Month is zero-based in JS

  return date.getFullYear() === year
    && date.getMonth() === month - 1
    && date.getDate() === day;
};

export const getDaysFromTodayDateString = (days = 1) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + days);

  const mm = String(tomorrow.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const dd = String(tomorrow.getDate()).padStart(2, '0');
  const yyyy = tomorrow.getFullYear();

  return `${mm}/${dd}/${yyyy}`;
};
